<template>
	<div class="applyrecord">
    <Scroller :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :no-data-text-data.sync="noDataText"
              @on-infinite="onInfinite"
              @on-refresh="onRefresh"
              class="my_scroller"
              ref="my_scroller"

    >
      <div class="list" v-if="list && list.length">
        <div class="listitem" v-for="(item, index) of list">
          <new-product-record-item :productItem="item" @finish="finish"></new-product-record-item>
        </div>
      </div>
    </Scroller>
    <empty v-if="empty" :path="'applyrecord'"></empty>
  </div>
</template>

<script>
import newProductRecordItem from '../common/newProductRecordItem'
import Scroller from '../common/Scroller'
import empty from '../emptypage/empty'
export default {
  name: 'applyrecord',
  components: {
    newProductRecordItem,
    Scroller,
    empty
  },
  data () {
    return {
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      pagesize: 10,
      noDataText: '',
      empty: false
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!sessionStorage.askPositon || (from.path == '/' && from.name != 'homePage')) { // 当前页面刷新不需要切换位置
      sessionStorage.askPositon = ''
      next(vm => {
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        vm.nowPage = 0
        vm.list = []
      })
    } else {
      next(vm => {
        vm.refresh = false
        vm.loading = false
        vm.finished = false
        vm.empty = false
        vm.nowPage = 0
        vm.list = []
        // if (vm && vm.$refs.my_scroller) { // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave (to, from, next) { // 记录离开时的位置
    // sessionStorage.askPositon = this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    this.loading = true
    next()
  },
  methods: {
    getData: function () {
      let url = this.$ajax.getUserApply_URL+'?pageNo=' + this.nowPage + '&pageSize=' + this.pagesize
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          let list = [], currtime = new Date().getTime()
          list = res.data.list.map(item => {
            item.countdown = new Date(item.time.replace(/-/g, '/')).getTime() - currtime
            return item
          })
          if (this.nowPage == 1) {
            this.list = list
            this.refresh = false
          } else {
            this.list = this.list.concat(list)
          }
          this.loading = false
          this.finished = list.length < this.pagesize
          if (this.nowPage == 1 && list.length == 0) this.empty = true
        }
      })
    },
    onRefresh () {
      this.refresh = true
      this.nowPage = 1
      this.getData()
    },
    onInfinite () {
      this.loading = true
      this.finished = false
      this.nowPage++
      this.getData()
    },
    finish () {

    }
  }
}
</script>

<style scoped lang="scss">
.applyrecord {
  margin: 0.1rem 0.11rem;
  .list {
    .listitem {
      margin-top: 0.1rem;
      &:first-of-type {
        margin-top: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newproducttrial/applyrecord.vue